var exports = {
  "h": "DesktopNotificationNagbar.module__description___SmJxc3",
};

module.exports = exports;
